import { AccountStructure } from "@models/accounts-structure";
import { DocumentStructure } from "@models/document-structure";

/**
 * If it is a Document Field, get its prefix. Otherwise return undefined.
 */
export function getDocumentFieldPrefix(field: AccountStructure | DocumentStructure): string | undefined {
  switch ((field as DocumentStructure).type) {
    case "חשבון":
      return "document_account";
    case "רכב":
      return "car";
    case "פריט":
      return "items";
    case "עבודה":
      return "works";
    default:
      return undefined;
  }
}
